import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {Illustration} from 'shells/illustrations/illustration';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {RouteContext} from '../../../route-context';

import {PrivacyPolicy} from '../../shared-components/privacy-policy';

import {redirectToFacebookOAuth} from '../helpers';

type Props = {
    errorMessage: string;
};

export function SettingsNoIntegration(props: Props) {
    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    return (
        <div className='flex'>
            <EmptyStateLarge
                title={`${isEmbedded ? 'Inbox FX' : ' Nutshell'} + Facebook and Instagram`}
                detailTextBullets={[
                    `Send and receive Facebook and Instagram messages via ${
                        isEmbedded ? 'Inbox FX' : 'the Nutshell inbox'
                    }`,
                    'Create leads from new messages',
                    'Choose which Facebook pages you’d like to sync',
                ]}
                icon={
                    isEmbedded ? (
                        <Illustration
                            fullPath='/include/images/messenger-instagram-bubble.png'
                            width={250}
                        />
                    ) : (
                        <Illustration
                            fullPath='/include/images/nutshell-messenger-instagram-bubble.png'
                            width={250}
                        />
                    )
                }
                iconSide='right'
                cta={
                    <StackLegacy spacing={16} alignCenter={true}>
                        {NutClientConfig.hasFacebookMessenger ? (
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => redirectToFacebookOAuth(isEmbedded)}
                            >
                                Continue to Facebook
                            </Button>
                        ) : (
                            <Link
                                icon={UpgradeArrowIcon}
                                href='/setup/billing/sales'
                                variant='button-upgrade'
                                size='big'
                            >
                                Upgrade to get started
                            </Link>
                        )}
                        {props.errorMessage && (
                            <Body size='small' color='error'>
                                {props.errorMessage}
                            </Body>
                        )}
                        <StackLegacy isHorizontal={true} spacing={8}>
                            <Link
                                href='https://www.messenger.com/'
                                variant='primary'
                                newTab={true}
                                size='small'
                            >
                                Learn more
                            </Link>
                            <Divider variant='dot' color={colors.black} />
                            <PrivacyPolicy variant='primary' size='small' isEmbedded={isEmbedded} />
                        </StackLegacy>
                    </StackLegacy>
                }
            />
        </div>
    );
}
